import { Form, Button } from 'react-bootstrap';
import { styled } from '@mui/material';

export const CustomFromLabel = styled(Form.Check.Label)`
  font-weight: 400;
  line-height: 19.84px;
`;

export const CustomForm = styled(Form.Check)`
  padding-left: 0;
`;

export const CustomFields = styled(Form.Group)`
  .is-invalid {
    ::placeholder {
      color: #e17171 !important;
    }
  }

  label {
    font-weight: 600;
    line-height: 17.36px;
  }

  input[type='checkbox'] {
    border: 2px solid #d8d8d8;
  }

  input[type='email'],
  input[type='text'] {
    border: 1px solid #d8d8d8;
    padding: 16px;
    height: 52px;
    border-radius: 8px;

    ::placeholder {
      font-weight: 400;
      opacity: 0.6;
    }
  }
`;

export const CustomButton = styled(Button)`
  background-color: #784af4;
  padding: 16px 48px;
  border-radius: 6px;
  border: none;
  font-weight: 700;
  box-shadow: 0 4px 14px rgba(120, 74, 244, 0.4);
  min-width: 150px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #6639d6;
    box-shadow: 0 6px 18px rgba(120, 74, 244, 0.5);
    transform: translateY(-1px);
  }

  &:active {
    background-color: #5530b8;
    box-shadow: 0 2px 8px rgba(120, 74, 244, 0.4);
    transform: translateY(0);
  }

  &:focus {
    background-color: #6639d6;
    box-shadow: 0 4px 14px rgba(120, 74, 244, 0.4), 0 0 0 0.2rem rgba(120, 74, 244, 0.25);
  }

  &:disabled {
    background-color: #9e9e9e;
    box-shadow: none;
    cursor: not-allowed;
    transform: none;
  }
`;

export const ButtonsContainer = styled('div')`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const PrevStepButton = styled(Button)`
  padding: 16px 40px;
  border-radius: 6px;
  background: transparent;
  border: 2px solid rgba(120, 74, 244, 0.5);
  color: #784af4;
  font-weight: 500;

  &:hover {
    background: rgba(120, 74, 244, 0.1);
    border: 2px solid rgba(120, 74, 244, 0.7);
    color: #784af4;
  }

  &:active {
    background: rgba(120, 74, 244, 0.15);
    border: 2px solid rgba(120, 74, 244, 0.7);
    color: #784af4;
  }

  &:focus {
    background: rgba(120, 74, 244, 0.1);
    border: 2px solid rgba(120, 74, 244, 0.7);
    color: #784af4;
    box-shadow: 0 0 0 0.2rem rgba(120, 74, 244, 0.25);
  }
`;
